<section *ngIf="invoice != undefined" class="invoice mat-elevation-z3">

    <div class="grid">
        <ap-pick-customer (customerChange)="updateCustomer($event)" [customer]="invoice.customer"></ap-pick-customer>

        <div class="invoice-details">
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Invoice number</mat-label>
                    <input matInput placeholder="#" [(ngModel)]="invoice.number">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>P.O/S.O. number</mat-label>
                    <input matInput placeholder="#" [(ngModel)]="invoice.custom">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Invoice Date</mat-label>
                    <input matInput [matDatepicker]="picker1" [(ngModel)]="invoice.dateCreated">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Due Date</mat-label>
                    <input matInput [matDatepicker]="picker2" [(ngModel)]="invoice.dateDue">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </p>
        </div>
    </div>

    <div class="invoice-items">

        <table mat-table [dataSource]="invoiceItemsDataSource">

            <ng-container matColumnDef="item">
                <th mat-header-cell *matHeaderCellDef> Item </th>
                <td apStatus="Item code" mat-cell class="item-cell" *matCellDef="let element">
                    <div class="input-group">
                        <input matInput [value]="element.item" [(ngModel)]="element.item">
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="desc">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element">
                    <textarea [(ngModel)]="element.desc" class="description" matInput cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1">{{element.desc}}</textarea>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="qty">
                <th mat-header-cell *matHeaderCellDef> Quantity </th>
                <td mat-cell class="qty-cell" *matCellDef="let element"><input matInput [value]="element.qty"
                        [(ngModel)]="element.qty"></td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef> Price ea.</th>
                <td mat-cell class="price-cell" *matCellDef="let element">
                    <ap-money (amountChange)="amountChanged($event, i)" class="amountInput" [(amount)]="element.price"></ap-money>
                </td>
                <td class="invoiceTotal" mat-footer-cell *matFooterCellDef>{{invoice.total | human}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell class="price-cell" *matCellDef="let element;let i = index">
                    <button (click)="deleteLineItem(i)" mat-icon-button>
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

        </table>


        <div class="add-line-item">
            <button mat-button (click)="addLineItem()">Add line item</button>
        </div>

        <div class="invoice-actions">
            <button (click)="save()" mat-raised-button color="primary">Save</button>
        </div>

    </div>

</section>